import {Record} from 'immutable';
import {ReduceStore} from 'flux/utils';
import ActionTypes from '../ActionTypes';
import AppDispatcher from '../AppDispatcher';

const State = new Record({
    courses: null,
});

class EventStore extends ReduceStore {
    constructor() {
        super(AppDispatcher);
    }

    getInitialState() {
        return new State();
    }

    reduce(state, action) {
        switch (action.type) {
            case ActionTypes.UPDATE_TOKEN_FAILED:
            case ActionTypes.LOGOUT:
            case ActionTypes.SELECT_COURSES_START:
                return state.clear();

            case ActionTypes.SELECT_COURSES_FINISH:
                return state.set('courses', action.courses);

            default:
                return state;
        }
    }
}

export default new EventStore();




// WEBPACK FOOTER //
// src/stores/EventsStore.js